// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__u0E0a","item":"PaymentsMobile_item__ADOMt","label":"PaymentsMobile_label__31L8Y","amount":"PaymentsMobile_amount__3CJgY"};